/* eslint-disable no-unused-vars */
import {
  Box,
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import DateRangePickerCustom from "../../components/dashboard/DateRangePicker";
import PredictedTrendsWithSelects from "../../components/dashboard/charts/PredictedTrendsWithSelects";
import DestinationSelect from "../../components/dashboard/prediction/DestinationSelect";
import ChevronRightIcon from "../../icons/ChevronRight";
import { hasPermission } from "../../utils/handlePermissions";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { formatISO, subDays } from "date-fns";
import { graphQLApiService } from "../../services/GraphQLApiService";
import {
  GET_DESTINATION_BY_PRICES,
  GET_REGIONS_AND_CITIES,
} from "../../queries/prediction/destinationQuery";
import { GET_TYPE_ENUMS } from "../../queries/prediction/tripAnalyticsQuery";
import { useTranslation } from "react-i18next";

const DestinationByPrices = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [mealTypes, setMealTypes] = useState([]);
  const [offerTypes, setOfferTypes] = useState([]);
  const [transportTypes, setTransportTypes] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState({ value: "Afitos" });

  const [datesWeek, setDatesWeek] = useState([]);
  const [statsWeek, setStatsWeek] = useState({ min: [], max: [], avg: [] });

  const [datesMonth, setDatesMonth] = useState([]);
  const [statsMonth, setStatsMonth] = useState({ min: [], max: [], avg: [] });

  const [datesDay, setDatesDay] = useState([]);
  const [statsDay, setStatsDay] = useState({ min: [], max: [], avg: [] });

  const [selectedCountry, setSelectedCountry] = useState("GR");
  const [selectedOfferType, setSelectedOfferType] = useState("STAY");
  const [selectedTransport, setSelectedTransport] = useState("FLIGHT");
  const [selectedDepartureCity, setSelectedDepartureCity] = useState("Gdansk");
  const [selectedPeriodLength, setSelectedPeriodLength] = useState(7);
  const [selectedMealCode, setSelectedMealCode] = useState("AI");

  const [selectionRange, setState] = useState([
    {
      startDate: subDays(new Date("2023-07-31"), 30),
      endDate: new Date("2023-07-31"),
      key: "selection",
    },
  ]);

  useEffect(() => {
    graphQLApiService.query(GET_TYPE_ENUMS, {}).then((result: any) => {
      setMealTypes(
        (result?.data?.MealCode?.enumValues || []).map((item) => ({
          label: item.description,
          value: item.name,
        }))
      );
      setOfferTypes(
        (result?.data?.Offer?.enumValues || []).map((item) => ({
          label: item.description,
          value: item.name,
        }))
      );
      setTransportTypes(
        (result?.data?.Transport?.enumValues || []).map((item) => ({
          label: item.description,
          value: item.name,
        }))
      );
    });
  }, [selectionRange]);

  useEffect(() => {
    graphQLApiService
      .query(GET_REGIONS_AND_CITIES, {
        startDate: formatISO(selectionRange[0].startDate).split("T")[0],
        endDate: formatISO(selectionRange[0].endDate).split("T")[0],
        countryCode: selectedCountry,
      })
      .then((result: any) => {
        if (result.data) {
          let cities = [];
          result.data.tripAnalytics?.country?.region?.cities?.nodes.forEach(
            (item) => {
              cities.push(item.name);
            }
          );
          setCities(cities);
        } else {
          setCities([]);
        }
      });
  }, [selectionRange, selectedCountry, selectedCity]);

  useEffect(() => {
    graphQLApiService
      .query(GET_DESTINATION_BY_PRICES, {
        startDate: formatISO(selectionRange[0].startDate).split("T")[0],
        endDate: formatISO(selectionRange[0].endDate).split("T")[0],
        countryCode: [selectedCountry],
        transportType: selectedTransport,
        offerType: selectedOfferType,
        departureCity: selectedDepartureCity,
        length: selectedPeriodLength || 7,
        mealCode: selectedMealCode,
        city: [],
        propertyName: [],
        departureDateStart: formatISO(selectionRange[0].startDate).split(
          "T"
        )[0],
        departureDateEnd: formatISO(selectionRange[0].endDate).split("T")[0],
        limit: 10000,
      })
      .then((result: any) => {
        const data =
          result?.data?.tripAnalytics?.statsByDeparture?.byWeek || null;
        if (data && data.length > 0) {
          let dates = [];
          let stat = { min: [], max: [], avg: [] };
          data.forEach((item) => {
            dates.push(`${item.week} week of ${item.year}`);
            stat.min.push(item.minimumBasePrice);
            stat.max.push(item.maximumBasePrice);
            stat.avg.push(item.averageBasePrice);
          });
          setDatesWeek(dates);
          setStatsWeek(stat);
        } else {
          setDatesWeek([]);
          setStatsWeek({ min: [], max: [], avg: [] });
        }

        const data2 =
          result?.data?.tripAnalytics?.statsByDeparture?.byMonth || null;
        if (data2 && data2.length > 0) {
          let dates = [];
          let stat = { min: [], max: [], avg: [] };
          data2.forEach((item) => {
            dates.push(`${item.year}-${item.month}`);
            stat.min.push(item.minimumBasePrice);
            stat.max.push(item.maximumBasePrice);
            stat.avg.push(item.averageBasePrice);
          });
          setDatesMonth(dates);
          setStatsMonth(stat);
        } else {
          setDatesMonth([]);
          setStatsMonth({ min: [], max: [], avg: [] });
        }

        const data3 =
          result?.data?.tripAnalytics?.statsByDeparture?.byDate || null;
        if (data3 && data3.length > 0) {
          let dates = [];
          let stat = { min: [], max: [], avg: [] };
          data3.forEach((item) => {
            dates.push(item.departureDate);
            stat.min.push(item.minimumBasePrice);
            stat.max.push(item.maximumBasePrice);
            stat.avg.push(item.averageBasePrice);
          });
          setDatesDay(dates);
          setStatsDay(stat);
        } else {
          setDatesDay([]);
          setStatsDay({ min: [], max: [], avg: [] });
        }
      });
  }, [
    selectionRange,
    selectedCountry,
    selectedCity,
    selectedTransport,
    selectedOfferType,
    selectedDepartureCity,
    selectedPeriodLength,
    selectedMealCode,
  ]);

  return (
    <>
      {hasPermission("dashboard_analytics_destination") && (
        <>
          <Helmet>
            <title>
              Dashboard: {t("title.Destination by prices")} | Qtravel Search
            </title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 4,
            }}
          >
            <Container>
              <Grid
                container
                alignItems="end"
                justifyContent="space-between"
                spacing={3}
              >
                <Grid item>
                  <Typography color="textPrimary" variant="h5">
                    {t("title.Destination by prices")}
                  </Typography>
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={<ChevronRightIcon fontSize="small" />}
                    sx={{ mt: 1 }}
                  >
                    <Link
                      color="textPrimary"
                      component={RouterLink}
                      to="/dashboard/main"
                      variant="subtitle2"
                    >
                      Dashboard
                    </Link>
                    <Typography color="textSecondary" variant="subtitle2">
                      {t("title.Destination by prices")}
                    </Typography>
                  </Breadcrumbs>
                </Grid>
                <Grid item>
                  <DateRangePickerCustom
                    color={"primary"}
                    label={t(`other.analyze_msg`)}
                  />
                </Grid>
              </Grid>
              <Typography color="textSecondary" variant="h6" sx={{ pt: 3 }}>
                {t("pages.prediction.select_msg")}
              </Typography>
              <Box sx={{ pt: 3 }}>
                <DestinationSelect
                  selectionRange={selectionRange}
                  countryChange={(country: any) => setSelectedCountry(country)}
                  citiesChange={(city: any) => setSelectedCity(city)}
                />
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsWithSelects
                  categories={[
                    "Week nr 21 22-28.05.2023",
                    "Week nr 22 29-04.06.2023",
                    "Week nr 23 05-11.06.2023",
                    "Week nr 24 12-18.06.2023",
                    "Week nr 25 19-25.06.2023",
                    "Week nr 26 26-02.07.2023",
                    "Week nr 27 03-09.07.2023",
                    "Week nr 28 10-16.07.2023",
                  ]}
                  data={{
                    min: [
                      1700.4, 2700, 3400.5, 3400.5, 4400.5, 4800.8, 5100.8,
                      4000.6,
                    ],
                    max: [
                      2300.1, 3100, 3800.1, 3900, 4500.1, 5800.9, 5800.5,
                      6600.5,
                    ],
                    avg: [2000, 2900, 3700, 3600, 4400, 5200, 5500, 5800],
                  }}
                  title={t(`other.departure_weeks`)}
                  tooltipInfo={t(`other.tooltip_Destination_country_1`)}
                />
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsWithSelects
                  categories={["May", "June", "July"]}
                  data={{
                    min: [800, 1500, 2200],
                    max: [1800, 1700, 2600],
                    avg: [1300, 1600, 2400],
                  }}
                  title={t(`other.departure_months`)}
                  tooltipInfo={t("other.tooltip_Destination_price")}
                />
              </Box>
            </Container>
          </Box>
        </>
      )}
    </>
  );
};

export default DestinationByPrices;
